module.exports = __webpack_public_path__ + "img/DSC_1089.31e2479e.jpg";